import React, { useEffect, useState } from "react";
import { Card, Modal, Space, Table } from 'antd';
import dayjs from 'dayjs';
import MyPresentButton from 'components/ui/Button/MyPresentButton';
import useGetEmployeeAttendnceLog from './useGetEmployeeAttendanceLog';
import AttendanceFilter from 'pages/attendance/AttendanceFilters';
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import { EMPLOYEE_ATTENDANCE_LOG } from "constants";
// import { checkUserPermissionFunc } from "components/common/CommonFuntion";
import { EmployeeDetails } from "components/common/CommonComponent";
import { useNavigate } from 'react-router-dom';
import { getDayWiseAttendanceByQuery } from "hooks/api/attendanceApi/dayWiseAttendanceApi";
import EditDayWiseAttendance from "../dayWiseAttendance/EditDayWiseAttendance";
import useApiData from "components/common/useGetApiData";
import useApiMethods from "hooks/apiConfig/method/apiMethods";
import { NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST, NEW_EMPLOYEE_ATTENDANCE_LOG } from "constant";
import MyButton from "components/ui/Button/MyButton";

const initialData = {
  employee_name: "",
  designation_name: "",
  department_name: "",
  status: ""
}

const statusConfig = {
  "present": { label: "P", bgColor: "#28A745", tipLabel: "Present" },
  "absent": { label: "A", bgColor: "#A72828", tipLabel: "Absent" },
  "holiday": { label: "HD", bgColor: "#EEBA35", tipLabel: "Holiday" },
  "on-duty": { label: "OD", bgColor: "#3595EE", tipLabel: "On Duty" },
  "week-off": { label: "WO", bgColor: "#F9827A", tipLabel: "WeekOff" },
  "compensation": { label: "Comp", bgColor: "#FEB8C3", tipLabel: "Compensation" },
  "WFH": { label: "WFH", bgColor: "#8DD6F5", tipLabel: "Work From Home" },
  "leave": { label: "L", bgColor: "#CCA6FC", tipLabel: "Leave" },
  "N/A": { label: "N/A", bgColor: "#b4b1b1", tipLabel: "Not Available" },
};

const AttendanceLog = () => {
  const query = "";
  const pageSize = 10;
  const dateFormat = "YYYY-MM-DD";
  const authtoken = sessionStorage.getItem("token");
  const today = new Date().toLocaleDateString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-');
  const is_super_admin = JSON.parse(sessionStorage.getItem("is_super_admin"));
  const is_admin = JSON.parse(sessionStorage.getItem("is_admin"));

  let isEditAccess = (is_super_admin || is_admin);

  let dateString;
  const [editVisible, setEditVisible] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState("");
  const [selectedDetails, setSelectedDetails] = useState({});
  const [dataUpdated, setDataUpdated] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs(today, dateFormat));
  const tableContainerHeight = "72vh";

  const currentMonth = new Date().getMonth();
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [daysInMonth, setDaysInMonth] = useState(new Date(currentYear, currentMonth + 1, 0).getDate());
  const [selectedmonth, setSelectedMonth] = useState(currentMonth + 1);
  const [dynamicColumns, setDynamicColumns] = useState([]);

  const [absentDialog, setAbsetDialog] = useState(false)
  const [absentDialogData, setAbsentDialogData] = useState({});
  const [reason, setReason] = useState("")

  useEffect(() => {
    if (!authtoken) {
      window.location.href = '/';
    }
  }, [authtoken]);

  const navigate = useNavigate();

  // const userPermission = checkUserPermissionFunc("attendance", "Attendance Log", "SubMenu");

  // const [data, pageInfo, loading, _message, refetch] =
  // useApiData(useGetEmployeeAttendnceLog, {selectedDate, pageNo, pageSize, query, searchText, sorting});


  const { fetch, update, create } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ pageNo: '', pageSize: '', query: '', search: '', sorting: '' })

  const fetchAttendanceLogData = async () => {
    const res = await fetch(
      NEW_EMPLOYEE_ATTENDANCE_LOG,
      filter,
      setLoading
    );
    if (res?.status) {
      setData(res.data.result);
      setPageInfo({
        pageNo: res.data.page_no,
        pageSize: res.data.page_size,
        totalCount: res.data.total_count,
        noOfPages: res.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
    fetchAttendanceLogData();
  }, [filter, dataUpdated, selectedDate, currentYear, selectedmonth]);

  const queryString =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&employee=" + (filterDatas.employee_name ? filterDatas.employee_name : "") +
    "&designation=" + (filterDatas.designation_name ? filterDatas.designation_name : "") +
    "&department=" + (filterDatas.department_name ? filterDatas.department_name : "") +
    "&status=" + (filterDatas.status ? filterDatas.status : "") +
    "&month=" + selectedmonth +
    "&year=" + currentYear +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const getEmployeeAttendanceById = async (id, date) => {
    try {
      const apiData = await getDayWiseAttendanceByQuery(`employee_id=${id ? id : null}&date=${date ? date : null}`);
      if (apiData && apiData.status === "success" && apiData.data && apiData.data.result && apiData.data.result.length > 0) {
        setSelectedDetails({ ...apiData.data.result[0] });
      } else {
        setSelectedDetails({});
      }
    } catch (error) {
      setSelectedDetails({});
    }
  }

  const handleViewDetails = (employeeId, data) => {
    if (employeeId) {
      setEditVisible(true);
      getEmployeeAttendanceById(employeeId, data);
    }
  }

  const openAbsentDialog = (employeeId, date) => {
    setAbsetDialog(true)
    getEmployeeAttendanceById(employeeId, date);
    setAbsentDialogData({ employeeId, date });
  };

  const closeAbsentDialog = () => {
    setAbsetDialog(false)
    setAbsentDialogData({})
  }

  const handleRequestCorrection = async () => {
    try {
      if (!selectedDetails || !selectedDetails.date || !selectedDetails.shiftDetails) {
        console.error("Incomplete data for correction request.");
        ToastMsg("error", "Missing shift details or date.");
        return;
      }

      const { date, shiftDetails: { shift_timings_from, shift_timings_to } } = selectedDetails;

      // Ensure shift timings are valid
      if (!shift_timings_from || !shift_timings_to) {
        console.error("Shift timings are missing");
        ToastMsg("error", "Shift timing details are incomplete.");
        return;
      }

      // Parse shift_timings_to and add 30 minutes
      const [h, m, s] = shift_timings_to.split(":").map(Number);
      const checkOut = new Date(0, 0, 0, h, m + 30, s || 0);
      const formattedCheckOut = checkOut.toTimeString().slice(0, 8); // => "HH:MM:SS"

      const payload = {
        date: date,
        requested_check_in: shift_timings_from,
        requested_check_out: formattedCheckOut,
        reason: reason.trim()
      };

      const response = await create(NEW_EMPLOYEE_ATTENDANCE_CORRECTION_REQUEST, payload, false);

      if (response?.status === "success") {
        ToastMsg("success", response.message || "Correction request submitted successfully.");
        setAbsentDialogData({});
        setAbsetDialog(false);
        setReason("");
        setDataUpdated(!dataUpdated);
      }
    } catch (error) {
      console.error("Error in handleRequestCorrection:", error);
      ToastMsg("error", error.message || "Failed to submit correction request.");
    }
  };

  useEffect(() => {
    const daysInMonth = dayjs(`${currentYear}-${selectedmonth}`).daysInMonth();
    const newColumns = [];

    // Generate dynamic columns for each day of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const columnDate = dayjs(`${currentYear}-${selectedmonth}-${day}`).format('YYYY-MM-DD');
      const columnConfig = {
        title: dayjs(columnDate).format('DD MMM'),
        dataIndex: columnDate,
        key: columnDate.toString(),
        render: (text, record) => {
          // Extract attendance data for the specific day
          const attendanceData = record.attendance_dict.find(item => item.date === columnDate);
          const status = attendanceData ? attendanceData.status : 'N/A';
          const statusInfo = status ? statusConfig[status] : statusConfig['N/A'];
          let { employee_details } = record;
          return <Space size="middle">
            <MyPresentButton
              label={statusInfo?.label}
              bgColor={statusInfo?.bgColor}
              tooltipLabel={statusInfo?.tipLabel}
              onClick={() => {
                if (!isEditAccess && statusInfo?.label === 'A' && statusInfo?.tipLabel === 'Absent') {
                  openAbsentDialog(employee_details?.id, columnDate);
                } else if (isEditAccess) {
                  handleViewDetails(employee_details?.id, columnDate);
                }
              }}
            />
          </Space>
        },
      };
      newColumns.push(columnConfig);
    }

    // Update the state with the new columns
    setDynamicColumns(newColumns);
  }, [currentYear, selectedmonth, data]);


  useEffect(() => {
    const newQuery = `employee_id=${filterDatas.employee_name || ""}`
      + `&designation=${filterDatas.designation_name || ""}`
      + `&department=${filterDatas.department_name || ""}`
      + `&status=${filterDatas.status || ""}`
      + `&search=${searchText}`
      + `&month= ${selectedmonth}`
      + `&year= ${currentYear}`
      + (sorting ? `&${sorting}` : "");

    setFilter((prevFilter) => ({
      ...prevFilter,
      query: newQuery,
    }));
  }, [filterDatas, searchText, sorting, selectedDate]);

  // Date changes start 
  // Filter the data based on the selected date
  const handleDateChange = async (date) => {
    setSelectedDate(date);
    dateString = dayjs(date).format("YYYY-MM-DD");
    setSelectedMonth(dayjs(date).format("MM"))
    setCurrentYear(new Date(dateString).getFullYear());
    setDaysInMonth(new Date(currentYear, dayjs(date).format("MM"), 0).getDate());
    setFilterDatas({ ...filterDatas, date: dateString });
    setDataUpdated(!dataUpdated);
  };

  const handleSearch = () => {
    setPageNo(1);
    setFilter((prevFilter) => ({
        ...prevFilter, 
        pageNo: 1, 
        pageSize: pageSize || prevFilter.pageSize, 
        query: queryString,
        search: searchText,
        sorting: sorting,
      }));
    setDataUpdated(!dataUpdated);
}

const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : "";
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: pagination.current, 
      pageSize: pagination.pageSize || prevFilter.pageSize, 
      query: queryString, 
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    setFilterVisible(false);
}

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = () => {
    setFilterDatas(initialData);
    setPageNo(1);
  }
  //filter end

  const handleClick = (empData) => {
    // let { employee_details } = empData;
    // navigate('/attendance/attendancelog/chart', { state: { employeeId: employee_details?.id ? employee_details?.id : null } })
  };

  const handleCancel = () => {
    setEditVisible(false);
    setSelectedDetails({});
  };

  const handleSave = () => {
    navigate('/attendance/attendancelog');
    setDataUpdated(!dataUpdated);
    setFilter(pageNo, pageSize, queryString, searchText, sorting);
  };

  const columns = [
    {
      title: "Employee Details",
      dataIndex: "employee_details",
      key: "employee_details",
      sorter: true,
      fixed: "left",
      width: 250,
      render: (_, record) => {
        let { employee_details } = record;
        let empDetails = {
          ...record,
          title: employee_details.title ? employee_details.title : "",
          first_name: employee_details.employee_name ? employee_details.employee_name : "",
          last_name: "",
          designation_id: {
            id: employee_details?.designation?.id ? employee_details?.designation?.id : "",
            designation_name: employee_details?.designation?.name ? employee_details?.designation?.name : ""
          },
          id: employee_details.employee_id,
          profile: employee_details.profile,
        }
        return (<span onClick={() => handleClick(record)} style={{ color: record.is_active ? "black" : "#CACACA", cursor: "pointer" }}>
          <EmployeeDetails details={empDetails} />
        </span>)
      }
    },
    {
      title: "Total Working days",
      dataIndex: "total_working_days",
      key: "total_working_days",
      sorter: true,
      fixed: "left",
      width: 180,
      align: "center",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (<span style={{ color: colors }}>{record?.total_working_days}</span>)
      }
    },
    {
      title: "Present",
      dataIndex: "present",
      key: "present",
      sorter: true,
      fixed: "left",
      width: 75,
      align: "center",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (<span style={{ color: colors }}>{record?.present}</span>)
      }
    },
    {
      title: "Absent",
      dataIndex: "absent",
      key: "absent",
      sorter: true,
      fixed: "left",
      width: 75,
      align: "center",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (<span style={{ color: colors }}>{record?.absent}</span>)
      }
    },
    ...dynamicColumns
  ];

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const printData =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&employee=" + (filterDatas.employee_name ? filterDatas.employee_name : "") +
    "&designation=" + (filterDatas.designation_name ? filterDatas.designation_name : "") +
    "&department=" + (filterDatas.department_name ? filterDatas.department_name : "") +
    "&status=" + (filterDatas.status ? filterDatas.status : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full">
      <div className={"h-1/6"} >
        <CommonTblHeader
          pageName={"Attendance log"}
          pageInfo={pageInfo}
          handleSearch={handleSearch}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          url={EMPLOYEE_ATTENDANCE_LOG} query={printData}
          isAddRequired={false} isDraftRequired={false}
          isDateRequired={true} handleDateChange={handleDateChange} selectedDate={selectedDate}
          format="MMM YYYY" picker="month" isPrintRequired={false}
          isExcelRequired={false}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center  mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <AttendanceFilter
              pageName={"AttendanceLog"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
          <Table
            columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
            dataSource={data?.length > 0 ? data : null}
            loading={loading}
            style={{ "--table-container-height": tableContainerHeight }}
            scroll={{ x: 3500, y: `calc(${tableContainerHeight} - 165px)` }}
            onChange={handleTableChange}
            pagination={{
              style: { marginRight: 20, padding: 0 },
              defaultPageSize: pageSize,
              showSizeChanger: false,
              showQuickJumper: true,
              total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
              pageSizeOptions: ["10", "20", "30"],
              pageSize,
              defaultCurrent: pageNo,
            }}
            key={dataUpdated ? "updated" : "not-updated"}
          />
        </div>
      </div>
      {(editVisible && Object.keys(selectedDetails).length > 0) ?
        <EditDayWiseAttendance
          editDetails={selectedDetails}
          onHide={handleCancel}
          onSave={handleSave}
          fromEdit={editVisible}
          isActive={isEditAccess}
        />
        : null}

        {absentDialogData && absentDialog && (
          <Modal
            title={`Absent Record of ${dayjs(absentDialogData?.date).format("DD MMM YYYY")}` }
            open={!!absentDialogData}
            centered
            onCancel={closeAbsentDialog}
            footer={[
              <MyButton
                label="Cancel"
                key="cancel"
                onClick={closeAbsentDialog}
                outlined={true}
                type="default"
              />,
              <MyButton
                label="Request Correction"
                key="request"
                type="primary"
                onClick={handleRequestCorrection}
                bgColor={"#D94853"}
              />,
            ]}
          >
            <div className="text-xs text-gray-700 space-y-3">
              <div>
                <p>
                  The employee has been marked as
                  <span className="font-semibold text-red-600"> Absent </span>
                  for the selected date.
                </p>
                <div className=" mt-2">
                  <label className="block font-medium text-gray-800 mb-1">Reason for Correction</label>
                  <textarea
                    rows={2}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm"
                    placeholder="E.g. Forgot to clock in due to network issue"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>

              <p className="text-xs italic text-gray-500">
                Note: All correction requests will be reviewed and are subject to approval by the admin.
              </p>
            </div>
          </Modal>
        )}
    </Card>
  );
};

export default AttendanceLog;
